import React, { useEffect, useState } from "react";
import { useAppContext } from "../AppContext"; // Adjust the path as needed
import axios from "axios";
import AdminOrdersGet from "./AdminOrdersComps/AdminOrdersGet";
import AdminTownsGet from "./AdminTownsComps/AdminTownsGet";
import AdminOrdersCreate from "../AdminMainPageComps/AdminOrdersComps/AdminOrdersCreate";

export default function AdminOrdersMP() {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <a
        style={{
          //marginTop: 20,
          fontSize: 20,
          fontWeight: 500,
        }}
      >
        {/* Orders Page */}
      </a>
      {/* <AdminOrdersCreate /> */}
      <AdminOrdersGet />
    </div>
  );
}
